var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-details view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: {
                numberOfStep: 1,
                textOfStep: _vm.$t("claim.details.stepTitle"),
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "view_content" }, [
      _c(
        "div",
        {
          staticClass: "errorMessage",
          class: {
            "errorMessage-visible":
              _vm.errorPropery ||
              _vm.errorResident ||
              _vm.errorAge ||
              _vm.errorAddress ||
              _vm.errorPostCodeNotFound ||
              _vm.errorSinisterNotFOund,
          },
        },
        [
          _c(
            "div",
            { staticClass: "errorMessage-container" },
            [
              _c("svgicon", {
                attrs: {
                  icon: "alert-circle",
                  height: "24",
                  width: "24",
                  color: "#EC513A",
                },
              }),
              _c("p", { staticClass: "text-medium redVidid mg mg--l-2" }, [
                _vm._v(_vm._s(_vm.errorMsgGeneral)),
              ]),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("claim.details.title")))]),
        _c(
          "div",
          { staticClass: "view_form" },
          [
            _c(
              "p",
              {
                staticClass: "text-medium text-subtitle text-inline mg mg--r-1",
              },
              [_vm._v(_vm._s(`${_vm.$t("claim.details.address.literal")}:`))]
            ),
            _c("p", { staticClass: "text-medium text-inline" }, [
              _vm._v(_vm._s(_vm.stateComWarrantyAddress)),
            ]),
            _c(
              "div",
              { staticClass: "map mg mg--b-5 mg--t-2" },
              [
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showStreetView,
                        expression: "showStreetView",
                      },
                    ],
                    attrs: { id: "warrantyProps_street-view" },
                  }),
                ]),
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showStreetView,
                          expression: "!showStreetView",
                        },
                      ],
                      staticClass: "warrantyProps__image",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "warrantyProps__placeholder" },
                        [
                          _c("svgicon", {
                            attrs: { icon: "fence", height: "78", width: "78" },
                          }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-medium mg mg--b-1 mg--t-6 black",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("claim.details.map.empty.title"))
                              ),
                            ]
                          ),
                          _c("p", { staticClass: "text-small black" }, [
                            _vm._v(
                              _vm._s(_vm.$t("claim.details.map.empty.text"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "mg mg--b-4" }, [
              _c(
                "p",
                {
                  staticClass:
                    "text-medium text-subtitle text-inline mg mg--r-1",
                },
                [
                  _vm._v(
                    _vm._s(`${_vm.$t("claim.details.propertyType.literal")}:`)
                  ),
                ]
              ),
              _c("p", { staticClass: "text-medium text-inline" }, [
                _vm._v(_vm._s(_vm.capitalizedWarrantyPropertyType())),
              ]),
            ]),
            _vm._l(_vm.moreThanTwoYearsOptions, function (option) {
              return option.key === _vm.stateWarrantyMoreThanTwoYears
                ? _c("div", { staticClass: "mg mg--b-4" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "text-medium text-subtitle text-inline mg mg--r-1",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            `${_vm.$t(
                              "claim.details.moreThanTwoYears.literal"
                            )}:`
                          )
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "text-medium text-inline" }, [
                      _vm._v(_vm._s(_vm.$t(option.literal))),
                    ]),
                  ])
                : _vm._e()
            }),
            _vm._l(_vm.residentTypeOptions, function (option) {
              return option.key === _vm.stateWarrantyResidentType
                ? _c("div", { staticClass: "mg mg--b-4" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "text-medium text-subtitle text-inline mg mg--r-1",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            `${_vm.$t("claim.details.residentType.literal")}:`
                          )
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "text-medium text-inline" }, [
                      _vm._v(_vm._s(_vm.$t(option.literal))),
                    ]),
                  ])
                : _vm._e()
            }),
          ],
          2
        ),
        _c("p", { staticClass: "text-medium center" }, [
          _vm._v(_vm._s(_vm.$t("claim.details.warningMsg"))),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c("ma-confrim-btn", {
          attrs: {
            handleButtonClick: _vm.handleConfirmInfo,
            title: _vm.$t("actions.continue"),
            shouldBeDisabled: _vm.isConfirmDisabled,
            btnType: "functionalBtn",
            "qa-claimDetails-button": "",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }